export const ifAutofocusedItem = (
  savedFilters: any = [],
  value: string = '',
) => {
  const findValue = savedFilters?.find((item: any) => {
    return item?.name === value
  })

  return !!findValue
}
